
"use strict";

var React = require('react');
var Immutable = require('immutable');
var ProgramGroupItem = require('./ProgramGroupItem.jsx');

class ProgramGroup extends React.Component {
	shouldComponentUpdate(nextProps) {
		const { model, name, showCategories, ...other } = this.props;
		if(!Immutable.is(model, nextProps.model)) { return true; }
		if(showCategories !== nextProps.showCategories) { return true; }
		if(name !== nextProps.name) { return true; }
		return false;
	}

	render() {
		const { model, name, showCategories, ...other } = this.props;

		if(!model || model.isEmpty()) { return false; }

		return (
			<section {...other} className="svtse_program-list-ao">

				<div className="svtse_program-list-ao-back">
					<span className="svt_icon svt_icon--arrow-up"> </span>
					<a href="#navigation_a-o" className="svtse_program-list-sticky__link">
						Till navigationen
					</a>
				</div>

				<h3 className="svtse_program-list-ao__heading">
					<div tabIndex="-1" className="svtse_program-list-ao__group-name" id={name}>{name}</div>
				</h3>
				<ul className="svtse_program-list-ao__list">
				{model.toArray().map(function(value){
						return (
							<ProgramGroupItem key={value.get('id')} model={value} showCategories={showCategories}/>
						);
				})}
				</ul>
			</section>
		);
	}
}

ProgramGroup.propTypes = {
		model: React.PropTypes.instanceOf(Immutable.List).isRequired
};

module.exports = ProgramGroup;



/** WEBPACK FOOTER **
 ** ./app/components/ProgramListHandler/ProgramGroup.jsx
 **/